module.exports = __webpack_public_path__ + "static/media/doctor.21bd5057.svg";